import { z } from 'zod';
import { PortalConsumerInSchema, StagedPortalConsumerInSchema } from '../base/portal.js';
import { PortalsServiceEventBaseSchema, portalsServiceEventType } from './service.js';
const portalEventType = (eventName) => portalsServiceEventType('portal', eventName);
export const PortalEventSchema = PortalsServiceEventBaseSchema.merge(z.object({
    type: portalEventType(),
    portal: z.unknown(),
}));
export const PortalActivatedEventSchema = PortalEventSchema.merge(z.object({
    type: portalEventType('activated'),
    portal: PortalConsumerInSchema,
}));
export const PortalDeactivatedEventSchema = PortalEventSchema.merge(z.object({
    type: portalEventType('deactivated'),
    portal: PortalConsumerInSchema.or(StagedPortalConsumerInSchema),
}));
export const PortalStagedEventSchema = PortalEventSchema.merge(z.object({
    type: portalEventType('staged'),
    portal: StagedPortalConsumerInSchema,
}));
